"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.Consumer = exports.PopoverContext = exports.defaultPopoverContext = void 0;

var _react = require("react");

var defaultPopoverContext = {
  use: 'default'
};
exports.defaultPopoverContext = defaultPopoverContext;
var PopoverContext = (0, _react.createContext)(defaultPopoverContext);
exports.PopoverContext = PopoverContext;
var Consumer = PopoverContext.Consumer,
    Provider = PopoverContext.Provider;
exports.Provider = Provider;
exports.Consumer = Consumer;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/context/PopoverContext.js
// module id = 160
// module chunks = 5 6 7